//TopBarYou.js
import React from 'react';
import { isBrowser, isSmartTV } from 'react-device-detect';
import { FaBell, FaSearch } from 'react-icons/fa';

const TopBarYou = ({
  titulo = "Dashboard",
  somAtivo,
  setSomAtivo,
  audioContextRef,
  setMostrarAvisoSom
}) => {

  const isDark = document.body.classList.contains("dark-mode");

  return (
    <div
      className="d-flex align-items-center justify-content-between px-3 shadow-sm"
      style={{
        height: "58px",
        position: "fixed",
        top: 0,
        left: isBrowser || isSmartTV ? "60px" : "0px",
        right: 0,
        zIndex: 1040,
        backgroundColor: isDark ? "#1f2937" : "#ffffff",
        color: isDark ? "#ffffff" : "#111827",
        width: isBrowser || isSmartTV ? "calc(100% - 60px)" : "100%",
      }}
    >
      {/* Esquerda: Título */}
      <div className="fw-bold text-truncate" style={{ maxWidth: '150px' }}>
        {titulo}
      </div>

      {/* Centro: Frase motivacional */}
      <div className="d-none d-md-block text-center topbar-frase">
        “Sua Evolução é a Nossa Missão.”
      </div>

{/* Direita: campo de busca + sininho */}
<div className="d-flex align-items-center gap-3" style={{ paddingRight: '10px', gap: '20px' }}>
  {/* 🔍 Campo de busca compactado */}
<div className="d-flex align-items-center" style={{ gap: "4px" }}>
  {/* Campo de busca primeiro */}
  <input
    type="text"
    className={`form-control form-control-sm ${isDark ? 'bg-dark text-white border-secondary' : ''}`}
    placeholder="Buscar..."
    style={{
      width: "160px",
      height: "36px",
      borderRadius: "4px"
    }}
  />

  {/* Botão de lupa à direita */}
  <button
    type="button"
    className={`btn btn-sm ${isDark ? 'btn-dark border-secondary text-white' : 'btn-light text-dark'}`}
    style={{
      width: "36px",
      height: "36px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "4px"
    }}
    title="Buscar"
  >
    <FaSearch />
  </button>

  {typeof somAtivo !== 'undefined' && (
  <button
    onClick={() => {
      if (!audioContextRef.current && typeof AudioContext !== "undefined") {
        audioContextRef.current = new AudioContext();
        audioContextRef.current.resume().then(() => {
          console.log("🔊 Áudio desbloqueado pelo botão da TopBar");
          setSomAtivo(prev => !prev);
          setMostrarAvisoSom(false); // oculta o modal se estava aberto
        });
      } else {
        setSomAtivo(prev => !prev);
      }
    }}
    className={`btn btn-sm ${somAtivo ? 'btn-outline-success' : 'btn-outline-danger'}`}
    title="Ativar/Desativar Som"
  >
    {somAtivo ? '🔔 Som Ativo' : '🔕 Som Desligado'}
  </button>
)}

</div>


  {/* 🔔 Notificações */}
  <div style={{ position: "relative", cursor: "pointer", paddingRight: "5px" }} title="Notificações">
    <FaBell style={{ fontSize: "20px" }} />
    <span
      className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
      style={{ fontSize: "10px" }}
    >
      3
    </span>
  </div>
</div>

    </div>
  );
};

export default TopBarYou;
